/* eslint-disable no-console */
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { uploadFotoReporte } from "../../utils";

const MAX_FILE_SIZE = 4 * 1024 * 1024; // 4MB
const MAX_FOTOS = 1;

const SubirFotoReporteModal = ({ show, onHide, onUploadSuccess, edificio, saleId, fotosActuales, userId }) => {
  const [archivo, setArchivo] = useState(null);
  const [preview, setPreview] = useState(null);
  const [fileError, setFileError] = useState("");
  const [saving, setSaving] = useState(false);

  const remaining = MAX_FOTOS - fotosActuales;

  const resetForm = () => {
    setArchivo(null);
    setPreview(null);
    setFileError("");
    setSaving(false);
  };

  const handleClose = () => {
    resetForm();
    onHide();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      setArchivo(null);
      setPreview(null);
      setFileError("");
      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      setArchivo(null);
      setPreview(null);
      setFileError("La imagen no puede superar 4 MB");
      e.target.value = "";
      return;
    }
    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
      setArchivo(null);
      setPreview(null);
      setFileError("Solo se permiten im\u00e1genes JPG, PNG o WebP");
      e.target.value = "";
      return;
    }
    setArchivo(file);
    setFileError("");
    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    if (!archivo || !saleId || !edificio?.id) return;
    setSaving(true);
    try {
      await uploadFotoReporte(archivo, {
        sale_id: saleId,
        idedificio: edificio.id,
        created_by: userId,
      });
      resetForm();
      onUploadSuccess();
    } catch (error) {
      console.error("Error subiendo foto:", error);
      setFileError("Error al subir la foto. Intente nuevamente.");
      setSaving(false);
    }
  };

  const canSave = archivo && saleId && edificio?.id && !saving && remaining > 0;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>Subir Foto — {edificio?.edificio || ""}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <label className="form-label fw-semibold mb-0">Imagen</label>
            <span className="badge bg-secondary">
              {remaining} {remaining === 1 ? "lugar" : "lugares"} disponible{remaining !== 1 ? "s" : ""}
            </span>
          </div>
          <input type="file" className="form-control" accept=".jpg,.jpeg,.png,.webp" onChange={handleFileChange} />
          {fileError && <small className="text-danger">{fileError}</small>}
          <small className="text-muted d-block mt-1">JPG, PNG o WebP. M&aacute;ximo 4 MB.</small>
        </div>

        {preview && (
          <div className="mb-3 text-center">
            <img
              src={preview}
              alt="Preview"
              style={{ maxWidth: "100%", maxHeight: 300, borderRadius: 6, objectFit: "contain" }}
            />
          </div>
        )}

        {edificio && (
          <div className="p-2 bg-light rounded border" style={{ fontSize: "0.85rem" }}>
            <div>
              <strong>Edificio:</strong> {edificio.edificio}
            </div>
            {(edificio.direccion || edificio.ubicacion) && (
              <div>
                <strong>Direcci&oacute;n:</strong> {edificio.direccion || edificio.ubicacion}
              </div>
            )}
            {edificio.pais && (
              <div>
                <strong>Pa&iacute;s:</strong> {edificio.pais}
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={saving}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={!canSave}>
          {saving ? "Subiendo..." : "Guardar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubirFotoReporteModal;
